export default __webpack_public_path__ + "static/media/js_icon.d50680d4.webp";